import { render, staticRenderFns } from "./FieldUser.vue?vue&type=template&id=bc68e4c2"
import script from "./FieldUser.vue?vue&type=script&lang=js"
export * from "./FieldUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports